import axios from "axios";
import { Message } from "element-ui"; // 如果有使用UI框架
import store from "@/store"; // 如果有使用Vuex
import router from "@/router";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 从环境变量获取API基础地址
  timeout: 60000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么

    // 1. 添加token
    const token = store.state.userInfo.token;
    if (token) {
      config.headers["Authorization"] = token;
      config.headers["token"] = token;
    }

    // 2. 设置Content-Type
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    // 3. 如果是GET请求，设置params
    if (config.method === "get") {
      config.params = config.params || {};
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    /* eslint-disable */
    const res = response.data;

    // 1. 根据业务状态码处理
    if (res.code !== 200 && res.code !== 1) {
      // 处理业务错误
      Message.error(res.msg || "Error");

      // 特定状态码处理
      if (res.code === -1 || res.code === 403) {
        // 登录过期或未授权
        // store.dispatch("user/resetToken").then(() => {
        //   router.push("/login");
        // });

        Message.error(res.msg || "Error");
        router.push("/login");
      } else if (res.code === 500) {
        // 服务器错误
        console.error("Server Error:", res.message);
      }

      return Promise.reject(new Error(res.message || "Error"));
    } else {
      // 返回有效数据
      return Promise.resolve(res.data !== undefined ? res.data : res);
    }
  },
  (error) => {
    // 对响应错误做点什么
    // 1. HTTP状态码处理
    if (error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          // store.dispatch("user/resetToken").then(() => {
          //   router.push({ name: "Login" });
          // });
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          error.message = `连接错误 ${error.response.status}`;
      }
    } else if (error.message.includes("timeout")) {
      error.message = "网络请求超时";
    } else if (error.message.includes("Network Error")) {
      error.message = "网络连接错误";
    }

    Message.error(error.message);
    return Promise.reject(error);
  }
);

/**
 * GET请求
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
const get = function (url, params = {}) {
  return service({
    url,
    method: "get",
    params,
  });
};

/**
 * POST请求
 * @param {String} url 请求地址
 * @param {Object} data 请求数据
 */
const post = function (url, data = {}) {
  return service({
    url,
    method: "post",
    data,
  });
};

/**
 * PUT请求
 * @param {String} url 请求地址
 * @param {Object} data 请求数据
 */
const put = function (url, data = {}) {
  return service({
    url,
    method: "put",
    data,
  });
};

/**
 * DELETE请求
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
const del = function (url, params = {}) {
  return service({
    url,
    method: "delete",
    params,
  });
};

/**
 * 文件上传
 * @param {String} url 请求地址
 * @param {Object} formData 表单数据
 * @param {Function} onUploadProgress 上传进度回调
 */
const upload = function (url, formData, onUploadProgress = null) {
  return service({
    url,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};
export const httpService = {
  get,
  post,
  del,
  upload,
  put,
};
export default httpService;
